import { render, staticRenderFns } from "./SysValueDetailManagagement.vue?vue&type=template&id=1cd92e8d&"
import script from "./SysValueDetailManagagement.vue?vue&type=script&lang=js&"
export * from "./SysValueDetailManagagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports